'use client'

import dynamic from 'next/dynamic'

// Lazy load SmoothScroll to reduce initial bundle size
const SmoothScroll = dynamic(() => import('@/components/SmoothScroll'), {
  ssr: false,
})

// Choose which initial-load loader to show. To revert to the spinning logo,
// flip this to 'spinner'. Both components live in src/components/PageLoader/.
const ACTIVE_LOADER: 'anniversary' | 'spinner' = 'anniversary'

const LoaderComponent = dynamic(
  () =>
    ACTIVE_LOADER === 'anniversary'
      ? import('@/components/PageLoader/AnniversaryLoader').then((mod) => ({
          default: mod.AnniversaryLoader,
        }))
      : import('@/components/PageLoader/PageLoader').then((mod) => ({
          default: mod.PageLoader,
        })),
  {
    ssr: false,
    // Load immediately, don't wait
    loading: () => null,
  },
)

export function ClientOnlyComponents() {
  return (
    <>
      <LoaderComponent />
      <SmoothScroll />
    </>
  )
}
